<script>
	import InfoPage from './InfoPage.svelte';
	import InfoSection from './InfoSection.svelte';
	import { Icon } from '../feathericons.js';

</script>

<InfoPage Title="Royston">

<svelte:fragment slot="blurb">
<InfoSection src="pics/royston.jpg" alt="Royston">
<p>Royston is a town on the edge of Hertfordshire and Cambridgeshire. It has a lot of amenities such as a train station with fast links to London kings cross and Cambridge, a large Tesco, a splash park, the amazing Therfield Heath, and even a BMX track. It is a little rough around the edges but I have been told countless times that there are nice areas ... I am yet to see them!</p>
<p><a href="https://www.roystontown.uk/" target="new">{@html Icon("external-link","small")} Royston town website</a></p>
</InfoSection>
</svelte:fragment>

<svelte:fragment slot="playgrounds">
<InfoSection id="royston_splash_park" Title="Splash Park" src="pics/roy-splash.jpg" alt="Royston Splash Park">
<p>
Located in the priory gardens Royston splash park is open daily throughout the summer months and is an endless source of entertainment.
</p>
</InfoSection>
</svelte:fragment>


<svelte:fragment slot="walks">
<InfoSection id="the_heath" Title="Therfield Heath" src="pics/roy-heath.jpg" alt="Therfield Heath">
<p>
The heath offers a huge array of walks, from hilly grass land, to forests, to being pelted with golf balls on the green. The hilly areas off beautiful views of the south Cambridgeshire. Once you are done with all that walking you can reward yourself with good food, a coffee, or something to dull the pain of aching muscles at the Heath bar.
</p>
</InfoSection>
</svelte:fragment>

<svelte:fragment slot="attractions">
<InfoSection id="royston_rockets" Title="Royston Rockets" src="pics/royston-rockets.jpg" alt="Royston Rockets">
<p>
A nicely kept BMX track that is perfect for a little spin. The ups are a little too steep and the downs a little too fast for a balance bike. Fun for adults as well!
</p>
</InfoSection>
</svelte:fragment>

</InfoPage>
